
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import("@/pages/home/page"));
const AboutPage = lazy(() => import("@/pages/about/page"));
const GreetingPage = lazy(() => import("@/pages/greeting/page"));
const ActivitiesPage = lazy(() => import("@/pages/activities/page"));
const MembershipPage = lazy(() => import("@/pages/membership/page"));
const RecordsPage = lazy(() => import("@/pages/records/page"));
const NewsPage = lazy(() => import("@/pages/news/page"));
const NewsArchivePage = lazy(() => import("@/pages/news-archive/page"));
const NewsPostPage = lazy(() => import("@/pages/news-post/page"));
const NewsEditPage = lazy(() => import("@/pages/news-edit/page"));
const AccessPage = lazy(() => import("@/pages/access/page"));
const LoginPage = lazy(() => import("@/pages/login/page"));
const GalleryPage = lazy(() => import("@/pages/gallery/page"));
const NotFoundPage = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/greeting',
    element: <GreetingPage />,
  },
  {
    path: '/activities',
    element: <ActivitiesPage />,
  },
  {
    path: '/membership',
    element: <MembershipPage />,
  },
  {
    path: '/records',
    element: <RecordsPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news-archive',
    element: <NewsArchivePage />,
  },
  {
    path: '/news-post',
    element: <NewsPostPage />,
  },
  {
    path: '/news-edit/:id',
    element: <NewsEditPage />,
  },
  {
    path: '/access',
    element: <AccessPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
